import {useCompanyContext} from '../compay/CompanyContext'

const OtpSuggestion = () => {
  const companyCtx = useCompanyContext()

  const handleCheckboxChange = (e) => {
    try {
      companyCtx.postOtpStatus.mutate({otpEnabled: e.target.checked})
    } catch (error) {
      console.log(error)
    }
  }

  const otpEnabled =
    companyCtx?.getOtpStatus?.data?.otpStatus?.[0]?.otpEnabled ?? true

  return (
    <div className='card p-5'>
      <h3 className='card-title'>OTP Verification</h3>
      <p>Do you want to enable OTP verification on login?</p>
      <div className='form-check'>
        <input
          className='form-check-input'
          type='checkbox'
          id='otpEnabledCheckbox'
          onChange={handleCheckboxChange}
          checked={otpEnabled}
        />
        <label className='form-check-label' htmlFor='otpEnabledCheckbox'>
          Yes, require OTP on login
        </label>
      </div>
      {!otpEnabled && (
        <p className='text-warning mt-2' style={{fontSize: 12}}>
          OTP is disabled — users will log in with email &amp; password only.
        </p>
      )}
    </div>
  )
}

export default OtpSuggestion
